import {Button, ButtonGroup, Divider, Icon} from '@mc/ui-v4';
import React, {MutableRefObject} from 'react';
import {mcMinus, mcNew} from '@mc/react-ui-icons';
import {MapEditorActions} from '@mc/react-mapio';
import './Zoomer.scss';

type Props = {
    mapRef: MutableRefObject<MapEditorActions>;
    disabled?: boolean;
    /** Mobilní public: zoom tlačítka jako samostatné kulaté buttony vedle sebe (ne button group). */
    round?: boolean;
};

export const Zoomer: React.FC<Props> = ({mapRef, disabled, round}) => {
    if (round) {
        return (
            <div className={'zoomer-round'}>
                <Button className={'drop-shadow'} style={'link'} icon={<Icon icon={mcNew} />} onClick={() => mapRef.current?.mapZoomEvent(true)} disabled={disabled} />
                <Button className={'drop-shadow'} style={'link'} icon={<Icon icon={mcMinus} />} onClick={() => mapRef.current?.mapZoomEvent(false)} disabled={disabled} />
            </div>
        );
    }
    return (
        <ButtonGroup className={'zoomer-wrapper drop-shadow'}>
            <Button style={'link'} icon={<Icon icon={mcNew} />} onClick={() => mapRef.current?.mapZoomEvent(true)} disabled={disabled} />
            <Divider />
            <Button style={'link'} icon={<Icon icon={mcMinus} />} onClick={() => mapRef.current?.mapZoomEvent(false)} disabled={disabled} />
        </ButtonGroup>
    );
};
